import {sleep} from '@benchling/js-utils';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {ChatSessionQuery, ChatSessionQueryVariables} from 'llm/chat-library/__generated/ChatSessionQuery';
import {CHAT_SESSION_QUERY} from 'llm/chat-library/useChatSessionEvents';

const POLL_TIMEOUT_MS = 1000;

/**
 * Polls the deep research message task until completion and returns the result.
 */
export async function pollDeepResearchMessage(
  chatId: string,
  abortSignal: AbortSignal | undefined,
  onProgress: (progressData: ChatSessionQuery) => boolean
): Promise<void> {
  while (true) {
    if (abortSignal?.aborted) {
      throw new DOMException('Deep research polling aborted', 'AbortError');
    }
    const chatProgress = await doQuerySafe<ChatSessionQuery, ChatSessionQueryVariables>(
      {query: CHAT_SESSION_QUERY},
      {
        variables: {
          chatSessionId: chatId,
          // Data used by onProgress callback.
          disableAllThreads: false,
        },
        fetchPolicy: 'network-only',
      }
    );
    const shouldContinuePolling = onProgress(chatProgress);
    if (!shouldContinuePolling) {
      return;
    }
    await sleep(POLL_TIMEOUT_MS);
  }
}
